import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminUserSummary {
  id: number;
  username: string;
}

interface AuthState {
  token: string | null;
  admin: AdminUserSummary | null;
  setSession: (token: string, admin: AdminUserSummary) => void;
  clear: () => void;
}

/**
 * Persists token + admin summary in localStorage. Same pattern as
 * creator-website's auth/store but keyed under 'snapmon-admin-session'
 * so the two portals don't collide when both run in dev.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      admin: null,
      setSession: (token, admin) => set({ token, admin }),
      clear: () => set({ token: null, admin: null }),
    }),
    { name: 'snapmon-admin-session' },
  ),
);
